
import { PropTypes } from 'prop-types';

const EventPopUp = ({ title, date, description }) => {
    return (
        <div className="flex flex-col gap-5 w-full   p-8 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
            <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
            <h3 className="w-auto  text-[1.13rem] font-medium ">published on {date}</h3>
            {description}
        </div>
    )
}
EventPopUp.propTypes = {
    title: PropTypes.string,
    date: PropTypes.string,
    description: PropTypes.any,
}
export default EventPopUp